<template>
    <loading v-model:active="isLoading" :can-cancel="false" :on-cancel="onCancel" :is-full-page="fullPage" />
    <div class="container-fluid">
         <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><router-link to="/user">Usuários</router-link></li>
                <li class="breadcrumb-item active" aria-current="page">Associação entre usuários</li>
            </ol>
        </nav>
        <div class="row" v-if="enable_error_list">
            <div class="col-xl-12 col-md-12 col-sm-12">
                <div class="alert alert-danger">
                    <ol>
                        <li v-for="(error, index) in errors" :key="index">{{ error[0] }}</li>
                    </ol>
                </div>
            </div>
        </div>
        <div class="row mt-4">
            <div class="col-xl-12 col-md-12 col-sm-12">
                <div class="card shadow mb-4">
                    <div class="card-header py-3 d-flex flex-row align-items-center justify-content-between">
                        <h6 class="m-0 font-weight-bold text-primary">Adicionar usuário</h6>
                    </div>
                    <div class="card-body">
                        <form @submit="save">
                            <div class="row">
                                <div class="col-lg-9 col-sm-9 col-xs-12">
                                    <label for="">Usuário*</label>
                                    <multiselect v-model="users_selected" :options="users_options"
                                        :custom-label="userWithLang" placeholder="Selecione uma opção"
                                        :select-label="'Clique para selecionar'" :deselect-label="'Clique para remover'"
                                        :multiple="true">

                                        <template #noResult>
                                            Nenhum usuário encontrado.
                                        </template>
                                    </multiselect>
                                </div>
                                <div class="col-lg-3 col-sm-3 col-xs-12">
                                    <label for="">&nbsp;</label>
                                    <button type="submit" class="btn btn-primary btnFull" @click="loadData"
                                        :disabled='!isDisabled'><i class="fa fa-check"></i>Associar
                                        usuários</button>
                                </div>
                            </div>
                        </form>

                    </div>
                </div>
            </div>
        </div>

        <div class="row mt-4">
            <div class="col-xl-12 col-md-12 col-sm-12">
                <div class="card shadow mb-4">
                    <!-- Card Header - Dropdown -->
                    <div class="card-header py-3 d-flex flex-row align-items-center justify-content-between">
                        <h6 class="m-0 font-weight-bold text-primary">Usuários associados</h6> <button
                            class="btn btn-warning btn-sm" @click="loadData()"><i class="fa fa-undo"></i> Recarregar
                            dados</button>
                    </div>
                    <div class="card-body">
                        <div class="table-responsive">
                            <table class="table" id="dataTable" width="100%" cellspacing="0">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Nome</th>
                                        <th class="text-center">Vinculado em</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(user_register, index) in users_register" :key="user_register.user.id">
                                        <td>{{ index + 1 }}</td>
                                        <td>{{ capitalizeValue(user_register.user.name) }} </td>

                                        <td class="text-center">{{ user_register.user.created_at }} </td>
                                        <td v-if="user.role != 'admin'">
                                            <div class="dropdown">
                                                <button class="btn btn-primary dropdown-toggle" type="button"
                                                    id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true"
                                                    aria-expanded="false">
                                                    Ações
                                                </button>
                                                <div class="dropdown-menu animated--fade-in"
                                                    aria-labelledby="dropdownMenuButton">
                                                    <button class="dropdown-item"
                                                        @click="deleteUser(user_register.id)">Excluir</button>
                                                </div>
                                            </div>
                                        </td>
                                        <td v-else> <button class="btn btn-primary dropdown-toggle" type="button"
                                                id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true"
                                                aria-expanded="false" disabled>
                                                Ações
                                            </button></td>
                                    </tr>
                                    <tr v-show="users_register.length <= 0">
                                        <td colspan="5" class="text-center">Nenhum registro encontrado</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

import api from '@/api';
import { handleRequestErrors } from '@/handleErrors';
import { capitalize } from '@/util';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import Multiselect from 'vue-multiselect'


export default {
    components: { Loading, Multiselect },
    data() {
        return {
            isLoading: true,
            fullPage: true,
            advanced_search: false,
            enable_error_list: false,
            users: [],
            users_register: [],
            users_options: [],
            user_multiselect: '',
            user: {
                id: ''
            },
            users_selected: []
        }
    },
    computed: {

        isDisabled: function () {
            return this.users_selected.length > 0;
        }
    },
    mounted() {
        this.isLoading = false;
        const id = this.$route.params.id;
        this.user.id = id;
        const response_uses = this.getUsers();
        response_uses.then(() => {
            this.users_options = this.users.map(item => ({
                key: item.id,
                value: item.name + ' / ' + item.role
            }));
        });
        this.loadData();
    },
    methods: {
        onCancel() { },



        userWithLang({ value }) {
            return value;
        },

        async getUsers() {
            this.isLoading = true;
            const response = api.get('/userListAll')
                .then((response) => {
                    this.users = response.data.users;
                    this.isLoading = false;
                }).catch(error => {
                    this.isLoading = false;
                    handleRequestErrors(error.status, error);
                })
            return response;
        },

        loadData() {
            this.isLoading = true;
            api.get('user/' + this.user.id + '/link')
                .then((response) => {
                    this.users_register = response.data.user_activities;
                    this.user = response.data.user;
                    this.isLoading = false;
                }).catch(error => {
                    this.isLoading = false;
                    handleRequestErrors(error.status);
                })
        },

        capitalizeValue(value) {
            return capitalize(value);
        },

        save(event) {
            event.preventDefault();
            this.enable_error_list = false;
            this.isLoading = true;
            const ids_selected = [];
            this.users_selected.forEach(user_id => {
                ids_selected.push(user_id.key);
            });

            api.post('/user/' + this.user.id + '/link', { 'users': ids_selected })
                .then(() => {
                    this.isLoading = false;
                    this.$notify({
                        title: "Sucesso",
                        text: "Usuário cadastrado com sucesso!",
                        type: 'success'
                    });
                    this.users_selected = [];
                    this.loadData();
                }).catch(error => {
                    this.isLoading = false;
                    if (error.status == 422) {
                        let response_errors = error.response.data.errors;
                        this.errors = response_errors;
                        this.enable_error_list = true;
                    }
                    handleRequestErrors(error.status, error);
                })
        },

        deleteUser(id) {
            this.$confirm(
                {
                    message: 'Deseja desacociar o usuário?',
                    button: {
                        no: 'Não',
                        yes: 'Sim'
                    },

                    callback: confirm => {
                        if (confirm) {
                            this.isLoading = true;
                            api.delete('/user/' + id + '/removeLink')
                                .then(() => {
                                    this.isLoading = false;
                                    this.$notify({
                                        title: "Sucesso",
                                        text: "Usuário desacociado com sucesso",
                                        type: 'success'
                                    });

                                    this.loadData();
                                }).catch(error => {
                                    this.isLoading = false;
                                    handleRequestErrors(error.status);
                                })
                        }
                    }
                }
            )
        },

    }
}
</script>

<style>
.btnFull {
    width: 100%;
}
</style>